import React, { useEffect, useRef, useState } from "react";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import localization from "assets/localization/localization";
import { sessionService } from "redux-react-session";
import { userLogOut } from "services/redux/auth/loginOtp/action";
import { useDispatch } from "react-redux";
import useLatLng from 'hooks/uselatlng/uselatlng';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import ModalPop from 'components/sales/modal/modal';
import DivLayout from 'components/sales/divLayout/divLayout';
import CardSection from 'components/sales/cardSection/cardSection';

import {
  employeeAttendanceData,
  employeeCheckOutData,
  getAttendanceLocationType,
  getAttendanceOfficeList,
  getAttendanceSiteList,
} from "services/redux/sales/attendance/action";
import { isWebView as checkWebView } from "services/utils/nativeBridge";

const Header = ({
  unreadCount,
  onClickReadAll,
  notificationsList,
  activeComponent,
  role,
  attCheckIn,
  attCheckInSite,
  isJourneyStarted = false,
  isDarwinCheckedIn = false,
  hasOpenDarwinDuty = false,
  hasOpenDutyToday = false,
  departmentId,
  viewCart = [],
  userAlert,
}) => {
  const signOutuser = useDispatch();

  const [usedetials, setUsedetials] = useState("");
  const [userName, setUserName] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [isNotificationsShow, setIsNotificationsShow] = useState(false);
  const [isAllow, setIsAllow] = useState(false);
  const useDtl = useRef(null);
  const notificationsOpen = useRef(null);
  const [cartList, setCartList] = useState([]);
  const islatlng = useLatLng();
  const [stopAutoCheckout, setStopAutoCheckout] = useState(false);
  const [isShowModel, setIsShowModel] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [deviceType, setDeviceType] = useState('');
  const [leadxRedirectUrl, setLeadxRedirectUrl] = useState("#");
const checkWebViewFlag = checkWebView();
  const handleUserDtl = async () => {
    const data = localStorage.getItem('loginDetails');
    if(data)
      setUsedetials(JSON.parse(data));

    // await sessionService
    //   .loadUser()
    //   .then((res) => {
    //     const { data } = res.loginDetails;
    //     console.log(data);
    //     setUsedetials(data);
    //   })
    //   .catch((err) => console.log(err));
  };

  // useEffect(() => {
  //    if(userAlert !== undefined) {console.log(userAlert[0].popup_show);
  //       console.log('alert ' + JSON.stringify(userAlert));
  //       if(userAlert[0].popup_show) {
  //         setIsShowModel(true);
  //         setPopupData(userAlert[0].popup_data); 
  //       }
  //    }
  // },[userAlert]);

  const handleModalHide = () => {
    setIsShowModel(false);
  };

  // console.log('data ' + JSON.stringify(popupData));

  useEffect(()=> {
    if(usedetials?.name) {
      const matches = usedetials.name.match(/\b(\w)/g); 
      setUserName(matches.join(''));
    }
  },[usedetials.name])


  useEffect(() => {
    if (getAttendanceLocationType) {
      getAttendanceLocationType();
    }
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
      
    }
  }, [islatlng]);

  useEffect(() => {
    setTimeout(() => {
      handleUserDtl();
    }, 100);
  }, [localStorage.getItem('loginDetails')]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     handleUserDtl();
  //   }, 100);
  // }, [sessionService]);

  const handleLogout = async () => {
    var isWebview = false;
    // CHECKOUT
    // console.log(attCheckInSite); return false;
    if(localStorage.getItem('isWebview')){
      isWebview = localStorage.getItem('isWebview');
    }
    console.log(isWebview); 
    if (isAllow) {
      alert(localization.locationPermission);
    }
    var attdId = 0;
    try {
      if(typeof attCheckInSite[0].id !== undefined){
        attdId = attCheckInSite[0].id;
      }
    } catch (error) {
      // ...
    }
    if (employeeAttendanceData !== null && isAllow === false && attdId !== 0 && stopAutoCheckout === true) {
      const data = {
        att_id:attdId,
        latitude: islatlng?.lat,
        longitude: islatlng?.lng,
        type: 2,
        
      };
      const isNotEmpty = handleValidateObj(data);
      if (isNotEmpty !== false) {
        const url = Config.attendance.storeEmployeeAttendanceData;
        const res = await axios.post(url, data);
        if (res.status && res.status === 200) {
          let elem = document.getElementById("search_current_location");
          if (elem) {
            elem.parentNode.removeChild(elem);
          }
          signOutuser(userLogOut());
          sessionService.deleteSession();
          sessionService.deleteUser();
          localStorage.removeItem("profileDetails");
          localStorage.clear();
          sessionStorage.clear();
          if(!checkWebView){
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }
        }
      }
    }else{
      let elem = document.getElementById("search_current_location");
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
      signOutuser(userLogOut());
      sessionService.deleteSession();
      sessionService.deleteUser();
      localStorage.removeItem("profileDetails");
      
      if(isWebview){
        // localStorage.clear();
        // sessionStorage.clear();
        // console.log("a");
        // const RNWebView = window?.ReactNativeWebView;
        // console.log(RNWebView);
        // console.log("RNWebView");
        // if (RNWebView) {
        //   const contentStr = {
        //     event: "LOGOUT",
        //     data: null,
        //     os: "ANDROID",
        //   };
          // console.log(contentStr);
          // return false;
          // localStorage.setItem("inputListData", inputList);
          // RNWebView.postMessage(JSON.stringify(contentStr));
          const RNWebView =  window["ReactNativeWebView"];
          if (RNWebView) {
            const contentStr = {
              event: "LOGOUT",
              data: null,
              os: "ANDROID",
            };
            RNWebView.postMessage(JSON.stringify(contentStr));
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
          if(!checkWebViewFlag){
            window.location.reload();
          } 
          }, 300);
        }
      }else{
        localStorage.clear();
        sessionStorage.clear();
        if(!checkWebViewFlag){
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }
      
    }

    //END CHECKOUT
    
  };

  const handleOutsideClick = (e) => {
    if (!useDtl.current.contains(e.target)) {
      setIsShow(false);
    }
    if (!notificationsOpen.current.contains(e.target)) {
      setIsNotificationsShow(false);
    }
  };

  const handleNotifications = async () => {
    onClickReadAll();
    setIsNotificationsShow(!isNotificationsShow);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    if (viewCart) {
      setCartList(viewCart);
    }
  }, [viewCart]);

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
  };

  useEffect(() => {
    // Set device type (mobile or desktop)
    // let platform = isMobileDevice();
    const userDetails = localStorage.getItem('loginDetails')
    if(!userDetails){
      setLeadxRedirectUrl("https://play.google.com/store/search?q=park%2B+leadx&c=apps&hl=en");
      return ;
    }
    const data = JSON.parse(userDetails);

    if (parseInt(data?.leadx_login_preference) === 2) {
      setLeadxRedirectUrl("https://play.google.com/store/apps/details?id=io.parkplus.ppleadx&hl=en");
    } else {
      setLeadxRedirectUrl("https://leadx-new.parkplus.io/");
    }
    // setDeviceType(isMobileDevice() ? 'Mobile' : 'Desktop');
  }, []);


  const activeAttendance = attCheckInSite?.[0];
  const hasLegacyCheckIn =
    attCheckIn?.length > 0 &&
    activeAttendance &&
    (activeAttendance.type_id == 1 ||
      String(activeAttendance.type || '').toLowerCase() === 'in');
  const isCheckedIn = role.includes(9)
    ? isJourneyStarted || hasLegacyCheckIn || hasOpenDutyToday
    : hasOpenDutyToday || hasLegacyCheckIn;

  const journeyAttendancePath = '/dashboard/check_in';
  const darwinAttendancePath = '/dashboard/attendance/check-in-checkout';
  const attendancePath = role.includes(9)
    ? hasOpenDarwinDuty
      ? darwinAttendancePath
      : journeyAttendancePath
    : darwinAttendancePath;

  return (
    <header className="main-header">
      <div className="logo">
        <span
          className="head-col sidebar-hamburger"
          onClick={() => document.body.classList.toggle("show-sidebar")}
        >
          <img src={Images?.hamburger} alt="" />
        </span>
        <Link to="/dashboard/pm-dashboard" className="head-col">
          <picture>
            <source media="(min-width:768px)" srcSet={Images?.Logo} />
            <img src={Images?.LogoMin} alt="Logo" width="99" />
          </picture>
          <span>{localization.fusion}</span>
        </Link>
      </div>
      <nav>
        <ul>
          {/*{departmentId.includes(3) && !role.includes(9) && (*/}
          {/*  <li className="treeview nav-li cart">*/}
          {/*    {(attCheckIn && attCheckIn.length >0 && attCheckInSite && attCheckInSite[0] && attCheckInSite[0].type_id && attCheckInSite[0].type_id == 1 ?*/}
          {/*          <Link to={"/dashboard/check_out"}>*/}
          {/*          <button className="btn btn-sm btn-danger">Check Out</button>*/}
          {/*        </Link>*/}
          {/*      :*/}
          {/*          <Link to={"/dashboard/check_in"}>*/}
          {/*          <button className="btn btn-sm btn-info">Check In</button>*/}
          {/*        </Link>*/}
          {/*      )}*/}
          {/*    */}
          {/*  </li>*/}
          {/*)}*/}
          <li className="treeview nav-li cart">
            <a href={leadxRedirectUrl} target="_blank">
              <button className="btn btn-sm btn-info">LeadX</button>
            </a>
          </li>
          <li className="treeview nav-li cart header-app-link">
            <Link to="/dashboard/valet-referral">
              <img
                src="https://parkplus-bkt-img.parkplus.io/production/social-community/public/pulseOfIndiaBanner_20260831130618177327_c432d6b3-ac28-45e8-b184-0bb56d02a110.webp"
                alt={localization.valetReferral}
                title={localization.valetReferral}
                width="40"
                height="40"
              />
            </Link>
          </li>
          <li className="treeview nav-li cart">
            {/* End journey / Check out live in DutyBar when already on duty — keep header for start only */}
            {!isCheckedIn && (
              role.includes(9) ? (
                <Link to={attendancePath} title={localization.startjourney}>
                  <button className="btn btn-sm btn-info header-journey-btn header-journey-icon-btn" type="button" aria-label={localization.startjourney}>
                    <svg className="header-journey-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                    <span className="header-journey-text">{localization.startjourney}</span>
                  </button>
                </Link>
              ) : (
                <Link to={attendancePath} title={localization.checkIn}>
                  <button className="btn btn-sm btn-info" type="button">{localization.checkIn}</button>
                </Link>
              )
            )}
          </li>
          <li ref={notificationsOpen} className="treeview nav-li notification">
            <Link to="#" onClick={handleNotifications}>
              <img src={Images?.bell} alt=""/>
              {unreadCount > 0 && (
                  <span className="notifications-count">{unreadCount}</span>
              )}
            </Link>
            <ul
                className={`treeview-menu scrollbar-styling notifications-list ${
                    isNotificationsShow ? "d-block" : ""
                }`}
            >
              {notificationsList && notificationsList.length > 0 ? (
                  notificationsList.map((item, ind) => {
                    return (
                        <li key={ind}>
                          <Link to="#">{item.notification_text}</Link>
                        </li>
                    );
                  })
              ) : (
                  <li>
                    <Link to="#" className="no-notification">
                      No Notifications
                    </Link>
                  </li>
              )}
            </ul>
          </li>
          <li
              ref={useDtl}
              className={`treeview nav-li admin-menu ${
                  isShow ? "dropdown-open" : ""
              }`}
          >
            <Link to="#" onClick={() => setIsShow(!isShow)}>
              {/* <span className="admin-icon">
                <img src={Images?.admin} alt="" />
              </span> */}
              <span className="admin-name">
                {usedetials?.name ? usedetials.name : "user Name"}
              </span>
              <span className="user-name short-name">{userName}</span>
              <img src={Images?.arrowDown} alt="" className="dropdown-icon"/>
            </Link>
            <ul className={`treeview-menu ${isShow ? "d-block" : ""}`}>
              <li>
                <Link to="/dashboard/profile">My Profile</Link>
              </li>

              <li>
                <Link to="#" onClick={handleLogout}>
                  Logout
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <ModalPop
          title={localization.scheduledActivity}
          show={isShowModel}
          handleModalHide={handleModalHide}
          keyboard
          backdrop
      >
        <div>
          <CardSection title={'Details'}>
            <div className="details-listing">
              <DivLayout
                  heading={'Site Number'}
                  data={popupData?.site_no}
              />
              <DivLayout
                  heading={'Activity Type'}
                  data={popupData?.type}
              />
              <DivLayout
                  heading={'Maintenance Date'}
                data={popupData?.maintaince_date}
            />
            <DivLayout
                heading={'Time Slot'}
                data={popupData?.slot}
            />
            <DivLayout
                heading={'Assigned To'}
                data={popupData?.slot}
            />
          </div>  
        </CardSection>
        <div className="line"></div>
       </div>
        {/* <div className="text-center">
          <a target="_blank" className="btn btn-primary" href={popupData?.url}>{localization.changeSlot}</a>
        </div> */}
      </ModalPop>
    </header>
  );
};

export default Header;
